import { EntityModel } from '@/interfaces'
import {
  ALL_ISSUU_CATALOG_BLOCKS_QUERY,
  CREATE_ISSUU_CATALOG_BLOCK_MUTATION,
  DELETE_ISSUU_CATALOG_BLOCK_MUTATION,
  FORCE_DELETE_ISSUU_CATALOG_BLOCK_MUTATION,
  SINGLE_ISSUU_CATALOG_BLOCK_QUERY,
  UPDATE_ISSUU_CATALOG_BLOCK_MUTATION,
} from './graphql'

const cmsIssuuCatalogBlockModel: EntityModel = {
  name: 'issuuCatalogBlock',
  namePlural: 'issuuCatalogBlocks',
  uniqueName: 'cmsIssuuCatalogBlock',
  uniqueNamePlural: 'cmsIssuuCatalogBlocks',
  path: 'cms/blocks/issuu_catalog_block',
  baseUrl: '/cms/blocks/issuu_catalog_blocks',
  translationPrefix: 'entities:cmsIssuuCatalogBlock.',
  getDisplayName: (values: any) => {
    return 'Issuu Catalog Block'
  },
  gql: {
    getAll: ALL_ISSUU_CATALOG_BLOCKS_QUERY,
    getSingle: SINGLE_ISSUU_CATALOG_BLOCK_QUERY,
    create: CREATE_ISSUU_CATALOG_BLOCK_MUTATION,
    update: UPDATE_ISSUU_CATALOG_BLOCK_MUTATION,
    delete: DELETE_ISSUU_CATALOG_BLOCK_MUTATION,
    forceDelete: FORCE_DELETE_ISSUU_CATALOG_BLOCK_MUTATION,
  },
  attributes: {
    publicationCode: {
      name: 'publicationCode',
      label: 'entities:cmsIssuuCatalogBlock.attributes.publicationCode.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
        {
          type: 'regex',
          pattern: /^[a-z0-9_-]*$/,
        },
      ],
    },
    accountName: {
      name: 'accountName',
      label: 'entities:cmsIssuuCatalogBlock.attributes.accountName.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
        {
          type: 'regex',
          pattern: /^[a-z0-9_]*$/,
        },
      ],
    },
  },
}

export default cmsIssuuCatalogBlockModel
